// src/Charts_cumulative.js
import React, { useEffect, useState } from 'react';
import { BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
 // Legend, 
  ResponsiveContainer, 
  Cell, 
  LabelList,  
  ReferenceLine // Добавляем компонент для линии 
  } from 'recharts';
import Cookies from 'js-cookie';
import axios from 'axios';
import { configEfficiencyLines } from './efficiencyLinesConfig';
import SideBar from "../../SideBar/SideBar";
import "../Charts.css";


const СumulativeChartComponent = ({ serverIP }) => {
  const [steps, setSteps] = useState([]);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showEfficiencyLines, setShowEfficiencyLines] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const selectedGame = Cookies.get('selectedGame');
        const url = `${serverIP}/v1/game/сharts?game_name=${selectedGame}`;
        const response = await axios.get(url);
        setSteps(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div>Загрузка данных...</div>;
  }

  if (error) {
    return <div>Ошибка: {error}</div>;
  }

  const scenario = steps[0]?.scenario;
  // Получение конфига трендлайнов
  const efficiencyLines = configEfficiencyLines(scenario);
  // Константы с максимальными значениями
  const scenarioAbsoluteMax = scenario.id == 1 ? 500 : 250
  const scenarioAbsoluteMin = scenario.id == 1 ? -100 : -100
  const MAX_ABSOLUTE_VALUE = scenarioAbsoluteMax; // Максимальное значение по модулю
  const MIN_ABSOLUTE_VALUE = scenarioAbsoluteMin; // Максимальное значение по модулю
  const Y_AXIS_DOMAIN = [MIN_ABSOLUTE_VALUE, MAX_ABSOLUTE_VALUE];
  const Y_TICKS = showEfficiencyLines 
  ? [MIN_ABSOLUTE_VALUE, MIN_ABSOLUTE_VALUE/2, 0] 
  : [MIN_ABSOLUTE_VALUE, MIN_ABSOLUTE_VALUE/2, 0, MAX_ABSOLUTE_VALUE/2, MAX_ABSOLUTE_VALUE];

  const renderCustomLabel = (props) => {
    const { x, y, width, value, index } = props;
    const currentStep = steps[currentStepIndex];
    
    if (!currentStep || !currentStep.teams || index >= currentStep.teams.length) {
      return null;
    }
  
    const entry = currentStep.teams[index];
    const numericValue = Number(entry?.total_team_score);
    const isMax = entry?.team_is_max;
    const textColor = isMax ? '#ffffff' : '#0170ba';
  
    // Определяем позицию в зависимости от условий
    let yPosition;
    if (isMax) {
      yPosition = y + 25; // Внутри столбца для максимальных
    } else {
      if (numericValue >= 0) {
        yPosition = y - 25; // Над столбцом для положительных
      } else {
        yPosition = y + 35; // Под столбцом для отрицательных
      }
    }
  
    return (
      <text
        x={x + width / 2}
        y={yPosition}
        fill={textColor}
        fontSize={40}
        fontWeight={600}
        textAnchor="middle"
        dominantBaseline="middle"
      >
        {Math.round(numericValue)}
      </text>
    );
  };

  const CustomXAxisTick = (props) => {
    const { x, y, payload } = props;
    
    return (
      <g transform={`translate(${x},${y})`}>
        <text 
          x={0} 
          y={0} 
          dy={30} 
          textAnchor="middle" 
          fill="#4a5568"
          fontSize="25px"  // Размер шрифта
          fontWeight="bold"
        >
          {payload.value}
        </text>
      </g>
    );
  };

  return (
    <>    
      <div className="steps-menu">
        {steps.map((step, index) => (
          <button
            key={index}
            onClick={() => setCurrentStepIndex(index)}
            className={index === currentStepIndex ? 'active' : ''}
          >
            Шаг {index + 1}
            {/*step.step_name*/}
          </button>
        ))}
      </div>

      <div className="charts-container">
        {steps.length > 0 && (
          <div className="chart-wrapper">
            {/*<h3>{steps[currentStepIndex].step_name}</h3>*/}
            <h3>Результаты на текущий момент
                <span 
                  onClick={() => setShowEfficiencyLines(!showEfficiencyLines)}
                  style={{
                    display: 'inline-block',
                    width: 16,
                    height: 16,
                    marginLeft: 10,
                    backgroundColor: showEfficiencyLines ? '#28a745' : '#ccc',
                    cursor: 'pointer',
                    border: '1px solid #999',
                    verticalAlign: 'middle'
                  }}
                  title="Линии эффективности"
                />
            </h3>
            <ResponsiveContainer width="100%" height={800}>
              <BarChart
                data={steps[currentStepIndex].teams}
                //margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                margin={{ top: 20, right: 30, left: 20, bottom: 30 }} // Увеличиваем нижний отступ
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis 
                  dataKey="team_name"
                  tick={<CustomXAxisTick />}
                  height={100} // Увеличиваем высоту для вмещения крупного текста
                  interval={0} // Показываем все подписи
                  label={{ 
                    value: 'Команды', 
                    position: 'bottom',
                    offset: 30,
                    //style: { fontSize: 42, fontWeight: 'bold' }
                  }} 
                />
                <YAxis
                  domain={Y_AXIS_DOMAIN}
                  ticks={Y_TICKS}
                  axisLine={{ stroke: '#666', strokeWidth: 1 }}
                  label={{ 
                    angle: -90, 
                    position: 'center',
                    offset: -10
                  }}
                />

                {/* Явная нулевая линия */}
                <ReferenceLine 
                  y={0} 
                  stroke="#666" 
                  strokeWidth={1}
                  strokeDasharray="0" // Убираем пунктир
                />

                {/*Отсечки эффективности красная,желтая,зеленая */}           
                {efficiencyLines.map((line, index) => (
                  <ReferenceLine 
                    key={index}
                    y={line.y} 
                    stroke={showEfficiencyLines ? line.stroke : "transparent"}
                    strokeDasharray="5 5" 
                    strokeWidth={2}
                    label={showEfficiencyLines ? 
                      { 
                        value: line.y, 
                        position: 'left', 
                        fill: line.labelFill, 
                        fontWeight: 'bold', 
                        fontSize: 24 
                      }
                      : false}
                  />
                ))}

                <Tooltip />

                <Bar 
                  dataKey="total_team_score" 
                  name="Результат"
                  barSize={80}
                >
                  {steps[currentStepIndex].teams.map((entry, index) => (
                    <Cell 
                      key={`cell-${index}`}
                      fill={entry.team_is_max ? '#ffa500' : '#0170ba'}
                    />
                  ))}
                  {/* Добавляем LabelList для отображения значений */}
                  <LabelList 
                    dataKey="total_team_score"
                    content={renderCustomLabel} // Используем кастомный рендер
                  />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </>
  );
};


function TeamStepСumulativeCharts({isAdmin, serverIP}) {
  return (
      <div >
          <SideBar 
            position={{ position: "relative", marginTop: 20 }} 
            blueСumulativeCharts={{ backgroundColor: "#0170ba", color: "#fff" }} 
            isAdmin={isAdmin}
          /> 
          <div >
              <СumulativeChartComponent  serverIP={serverIP}/>
          </div>
      </div>
  );
}

export default TeamStepСumulativeCharts;